export default __webpack_public_path__ + "static/GRID22-25-countries-es-82574c164bee331beed9a96c099dc775.png";